var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf"},[_c('div',{staticClass:"show"},_vm._l((_vm.numPages),function(i){return _c('div',{key:i,staticClass:"p-pdf"},[_c('pdf',{staticClass:"pdfbox",attrs:{"src":_vm.pdfUrl,"page":i}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010cbf45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/pdf3.vue
// module id = null
// module chunks = 